import { fg } from '@atlassian/jira-feature-gating';

/** @deprecated Remove when cleaning up `nav4_visual_refresh_merger` */
export const getWillShowNav4UserOptOutForVisualRefresh = () =>
	fg('visual-refresh') &&
	(fg('visual-refresh-dogfood') ||
		fg('visual-refresh-eap') ||
		fg('visual-refresh-beta-existing-customers'));
